export default "__VITE_ASSET__P$KaFSXi__"